module.exports = __webpack_public_path__ + "img/88.fba5599d.png";